import { Component } from '@gasman/smush';
import { NumberGrid } from './grid';

class NumberRow extends Component {
    constructor(opts) {
        /*
        recognised opts:
        length
        property
        setter
        changeEvent
        */
        super();
        this.length = opts.length || 32;
        this.property = opts.property;
        this.setter = opts.setter;
        this.changeEvent = opts.changeEvent;

        this.receiver = null;
        this.undoBuffer = null;
        this.undoPath = null;

        this.grid = null;
    }

    render(container) {
        this.grid = new NumberGrid(container, {
            // className: 'position-editor',
            rows: 1,
            columns: this.length,
            getValue: (x) => {
                if (!this.receiver) return 0;
                return this.receiver[this.property][x];
            },
            commitValue: (x, y, val) => {
                let oldValue = this.receiver[this.property][x];
                if (oldValue == val) return;

                this.receiver[this.setter](x, val);

                if (this.undoBuffer) {
                    this.undoBuffer.push({
                        path: this.undoPath,
                        forward: { [x]: val },
                        reverse: { [x]: oldValue },
                    });
                }
            },
        });
    }

    bind(receiver, opts) {
        opts = opts || {};
        this.unbind();
        this.receiver = receiver;

        if (opts.undoBuffer) {
            this.undoBuffer = opts.undoBuffer;
            this.undoPath = [...opts.undoPath, this.property];
        }

        receiver.on(this.changeEvent, this.onChangeValue);
        if (this.grid) {
            var arr = this.receiver[this.property];
            for (let i = 0; i < this.length; i++) {
                this.grid.setValue(i, 0, arr[i]);
            }
        }
    }

    unbind() {
        if (this.receiver) {
            this.receiver.removeListener(this.changeEvent, this.onChangeValue);
            this.receiver = null;
            this.undoBuffer = null;
            this.undoPath = null;
        }
    }

    onChangeValue = (i, value) => {
        this.grid.setValue(i, 0, value);
    };

    static forField(field, opts) {
        return new NumberRow({
            length: field.length,
            property: field.name,
            setter: field.setterName,
            changeEvent: field.eventName,
            ...opts,
        });
    }
}

export { NumberRow };
